import undoable, { excludeAction } from "redux-undo";
import {
  ADDITIONAL_HERB_ADDED_TO_FORMULA,
  ALL_HERB_LIST_RECEIVED,
  CLASSIC_FORMULA_LIST_RECEIVED,
  CUSTOM_FORMULA_LIST_RECEIVED,
  DISEASES_RECEIVED,
  FAVORITE_FORMULA_LIST_RECEIVED,
  FORMULA_BY_ID_RECEIVED,
  FORMULA_HERB_ITEM_EDITED,
  FORMULA_LOCKED,
  FORMULA_REMOVED_FROM_SECTION,
  FORMULA_TOTAL_CHANGED,
  FORMULA_TYPE_CHANGED,
  FORMULA_TYPE_CHANGED_FROM_RAW_TO_GRANULAR,
  FORMULA_TYPE_CHANGED_FROM_GRANULAR_TO_RAW,
  HERBS_BY_FORMULA_ID_RECEIVED,
  HERBS_BY_ID_RECEIVED,
  HERB_REMOVED_FROM_FORMULA,
  MODIFICATION_BY_FORMULA_ID_RECEIVED,
  MODIFICATION_BY_ID_RECEIVED,
  RENDER_FORMULA_LIST,
  SET_ACTIVE_CUSTOM_FORMULA,
  SINGLE_HERB_ADDED_TO_LIST,
  SINGLE_HERB_FROM_PRESCRIPTION_ADDED_TO_LIST,
  SINGLE_HERB_ITEM_EDITED,
  SINGLE_HERB_LIST_LOCKED,
  SINGLE_HERB_REMOVED_FROM_LIST,
  SINGLE_HERB_TOTAL_CHANGED,
  SUBCLASS_BY_ID_RECEIVED,
  ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED,
} from "../constants/types/formulaType";
import { CLEAR_UNFINALIZED_PRESCRIPTION } from "../constants/types/prescriptionType";
import { constructDisplayText, getFixedDosage } from "../utils/helper";

const initialState = {
  favoriteFormulaList: [],
  customFormulaList: [],
  classicFormulaList: [],
  modificationByFormulaList: [],
  diseaseList: [],
  subclassByIdList: [],
  formulaByIdList: [],
  modificationByIdList: [],
  allHerbList: [],
  herbsByFormulaId: [],
  formulaSection: [],
  singleHerbList: [],
  isRawType: true,
  singleHerbTotal: {
    totalPrice: 0,
    totalDosage: 0,
  },
  overall: {
    totalPrice: 0,
    totalDosage: 0,
  },
  renderFormulaList: true,
  singleHerbLocked: false,
  activeCustomFormula: null,
};

const formulaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_CUSTOM_FORMULA: {
      return {
        ...state,
        activeCustomFormula: action.payload,
      };
    }
    case RENDER_FORMULA_LIST: {
      return {
        ...state,
        renderFormulaList: action.payload,
      };
    }
    case SINGLE_HERB_LIST_LOCKED: {
      return {
        ...state,
        singleHerbLocked: action.payload,
      };
    }
    case FORMULA_LOCKED: {
      const index = state.formulaSection.findIndex(
        (x) => x.formulaId === action.payload.id
      );
      const newFormulas = JSON.parse(JSON.stringify(state.formulaSection));
      newFormulas[index].isLocked = action.payload.isLocked;
      return {
        ...state,
        formulaSection: newFormulas,
      };
    }
    case CLEAR_UNFINALIZED_PRESCRIPTION: {
      return {
        ...state,
        singleHerbList: [],
        formulaSection: [],
        singleHerbTotal: {
          totalPrice: 0,
          totalDosage: 0,
        },
        singleHerbLocked: false,
        overall: {
          totalPrice: 0,
          totalDosage: 0,
        },
        activeCustomFormula: null,
      };
    }
    case FAVORITE_FORMULA_LIST_RECEIVED: {
      return {
        ...state,
        favoriteFormulaList: action.payload,
      };
    }

    case CUSTOM_FORMULA_LIST_RECEIVED: {
      return {
        ...state,
        customFormulaList: action.payload,
      };
    }

    case MODIFICATION_BY_FORMULA_ID_RECEIVED: {
      return {
        ...state,
        modificationByFormulaList: action.payload,
      };
    }

    case CLASSIC_FORMULA_LIST_RECEIVED: {
      return {
        ...state,
        classicFormulaList: action.payload,
      };
    }

    case DISEASES_RECEIVED: {
      return {
        ...state,
        diseaseList: action.payload,
      };
    }

    case ALL_HERB_LIST_RECEIVED: {
      return {
        ...state,
        allHerbList: action.payload,
      };
    }

    case SUBCLASS_BY_ID_RECEIVED: {
      return {
        ...state,
        subclassByIdList: action.payload,
      };
    }

    case FORMULA_BY_ID_RECEIVED: {
      return {
        ...state,
        formulaByIdList: action.payload,
      };
    }

    case HERBS_BY_FORMULA_ID_RECEIVED: {
      let herbList = [];
      action.payload.data.forEach((x) => {
        const item = {
          dosage:
            x.INV_ID_Granular == null
              ? 0
              : parseFloat((x?.FORM_Dosage || x?.dosage) ?? 0),
          dosageInFloat:
            x.INV_ID_Granular == null
              ? 0
              : parseFloat((x?.FORM_Dosage || x?.dosage) ?? 0),
          name: x?.HERB_Display
            ? constructDisplayText(
                x?.HERB_Display,
                x?.HERB_Latin_Name,
                x?.HERB_Chinese_Name,
                x?.INV_ID_Granular
              )
            : constructDisplayText(
                x?.herb_display,
                x?.HERB_Latin_Name,
                x?.HERB_Chinese_Name,
                x?.INV_ID_Granular
              ),

          id: x?.HERB_ID || x?.herb_id,
          rawRatio: x?.HERB_Raw_Ratio,
          granularUnit: x?.HERB_Granular_Unit,
          isToxic: x?.HERB_Is_Toxic,
          rawQuantity: x?.Raw_Quantity,
          granularQuantity: x?.Granular_Quantity,
          isCustom: x.is_custom_form ? 1 : action.payload.isCustom ? 1 : 0,
          price:
            Math.ceil(
              ((parseFloat((x?.FORM_Dosage || x?.dosage) ?? 0) *
                (state.isRawType
                  ? (x?.Price_Raw || x.price_raw) ?? 0
                  : (x?.Price_Granular || x?.price_granular) ?? 0)) /
                10000) *
                100
            ) / 100,
          rawPrice: (x?.Price_Raw || x.price_raw) ?? 0,
          granularPrice: (x?.Price_Granular || x.price_granular) ?? 0,
          isAdditional: x.is_form_additional,
          isModification: false || x?.mod_id > 0,
          modId: x?.mod_id > 0 ? x?.mod_id : 0,
        };
        herbList.push(item);
      });

      const formulaItem = {
        formulaHerbs: herbList,
        formulaName: action.payload.formula_name,
        formulaId: action.payload.formula_id,
        modificationName: action.payload?.modification_name,
        isLocked: false,
        formulaDosage: parseFloat(
          herbList.map((x) => x.dosage).reduce((sum, val) => sum + val, 0)
        ),
        formulaPrice: parseFloat(
          herbList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        ),
      };
      herbList.forEach((x) => {
        x.percentage = formulaItem.formulaDosage
          ? x.dosageInFloat / formulaItem.formulaDosage
          : 0;
      });
      if (parseFloat(action.payload.dosage) > 0) {
        herbList.forEach((y) => {
          let dosageInFloat = y.percentage * parseFloat(action.payload.dosage);
          let dosage = getFixedDosage(dosageInFloat);
          y.dosageInFloat = dosageInFloat;
          y.price =
            Math.ceil(
              ((parseFloat(dosage) *
                (action.payload.isRaw
                  ? y.rawPrice ?? 0
                  : y.granularPrice ?? 0)) /
                10000) *
                100
            ) / 100;
          y.dosage = dosage;
        });
        formulaItem.formulaDosage = parseFloat(
          herbList.map((x) => x.dosage).reduce((sum, val) => sum + val, 0)
        );
        formulaItem.formulaPrice = parseFloat(
          herbList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        );
      }
      const newList = state.formulaSection.concat(formulaItem);

      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          state.singleHerbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });

      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case HERBS_BY_ID_RECEIVED: {
      const index = state.formulaSection.findIndex(
        (x) => x.formulaId === action.payload.formula_id
      );
      const newList = JSON.parse(JSON.stringify(state.formulaSection));

      action.payload.herbs.forEach((x) => {
        const item = {
          dosage: parseFloat(x.MOD_Dosage ?? 0),
          dosageInFloat: parseFloat((x?.MOD_Dosage || x?.dosage) ?? 0),
          name: constructDisplayText(
            x?.HERB_Display,
            x?.HERB_Latin_Name,
            x?.HERB_Chinese_Name,
            x?.INV_ID_Granular
          ),
          id: x.HERB_ID,
          rawRatio: x.HERB_Raw_Ratio,
          granularUnit: x?.HERB_Granular_Unit,
          isToxic: x?.HERB_Is_Toxic,
          rawQuantity: x?.Raw_Quantity,
          granularQuantity: x?.Granular_Quantity,
          isCustom: x.is_custom_form ? 1 : 0,
          price:
            Math.ceil(
              ((parseFloat(x.MOD_Dosage) *
                (state.isRawType ? x.Price_Raw ?? 0 : x.Price_Granular ?? 0)) /
                10000) *
                100
            ) / 100,
          rawPrice: x.Price_Raw ?? 0,
          granularPrice: x.Price_Granular ?? 0,
          isAdditional: x.is_form_additional ? 1 : 0,
          isModification: true,
          modId: action.payload.mod_id,
        };
        newList[index].formulaHerbs.push(item);
      });

      newList[index].formulaDosage = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.dosage)
          .reduce((sum, val) => sum + val, 0)
      );
      newList[index].formulaPrice = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      newList[index].modificationName = action.payload.mod_name;
      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          state.singleHerbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case ADDITIONAL_HERB_ADDED_TO_FORMULA: {
      const item = {
        dosage: 0,
        dosageInFloat: 0,
        name: constructDisplayText(
          action.payload.herb?.HERB_Display,
          action.payload.herb?.HERB_Latin_Name,
          action.payload.herb?.HERB_Chinese_Name,
          action.payload.herb?.INV_ID_Granular
        ),
        id: action.payload.herb.HERB_ID,
        rawRatio: action.payload.herb.HERB_Raw_Ratio,
        granularUnit: action.payload.herb.HERB_Granular_Unit,
        isToxic: action.payload.herb.HERB_Is_Toxic,
        rawQuantity: action.payload.herb.Raw_Quantity,
        granularQuantity: action.payload.herb.Granular_Quantity,
        isCustom: false,
        price: 0,
        rawPrice: action.payload.herb.Price_Raw ?? 0,
        granularPrice: action.payload.herb.Price_Granular ?? 0,
        isAdditional: 1,
        isModification: false,
        modId: 0,
      };

      const index = state.formulaSection.findIndex(
        (x) => x.formulaId === action.payload.formulaId
      );

      const newList = JSON.parse(JSON.stringify(state.formulaSection));
      newList[index].formulaHerbs.push(item);
      return {
        ...state,
        formulaSection: newList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage:
            parseFloat(
              newList
                .map((x) => x.formulaDosage)
                .reduce((sum, val) => sum + val, 0)
            ) + state.singleHerbTotal.totalDosage,
        },
      };
    }

    case FORMULA_REMOVED_FROM_SECTION: {
      let newList = JSON.parse(JSON.stringify(state.formulaSection));
      newList = newList.filter((x) => x.formulaId !== action.payload);
      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          state.singleHerbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case HERB_REMOVED_FROM_FORMULA: {
      const index = state.formulaSection.findIndex(
        (x) => x.formulaId === action.payload.formulaId
      );
      const newList = JSON.parse(JSON.stringify(state.formulaSection));
      newList[index].formulaHerbs = newList[index].formulaHerbs.filter(
        (x) => x.id !== action.payload.herbId
      );
      newList[index].formulaDosage = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.dosage)
          .reduce((sum, val) => sum + val, 0)
      );
      newList[index].formulaPrice = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          state.singleHerbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case FORMULA_HERB_ITEM_EDITED: {
      const index = state.formulaSection.findIndex(
        (x) => x.formulaId === action.payload.formulaId
      );
      const newList = JSON.parse(JSON.stringify(state.formulaSection));
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      var herbIndex = newList[index].formulaHerbs.findIndex(
        (x) => x.id === action.payload.herbId
      );

      let prevLeftDosage =
        newList[index].formulaDosage -
        newList[index].formulaHerbs[herbIndex].dosage;

      let prevLeftOverallDosage =
        state.overall.totalDosage -
        newList[index].formulaHerbs[herbIndex].dosage;
      newList[index].formulaHerbs[herbIndex].dosage = parseFloat(
        parseFloat(action.payload.dosage)
      );
      newList[index].formulaHerbs[herbIndex].dosageInFloat = parseFloat(
        parseFloat(action.payload.dosage)
      );
      newList[index].formulaHerbs[herbIndex].price =
        Math.ceil(
          ((parseFloat(action.payload.dosage) *
            (state.isRawType
              ? newList[index].formulaHerbs[herbIndex].rawPrice ?? 0
              : newList[index].formulaHerbs[herbIndex].granularPrice ?? 0)) /
            10000) *
            100
        ) / 100;

      if (action.payload.isLocked) {
        let weight =
          newList[index].formulaDosage - parseFloat(action.payload.dosage);
        newList[index].formulaHerbs.forEach((x) => {
          if (x !== newList[index].formulaHerbs[herbIndex]) {
            let dosageInFloat = isNaN(x.dosageInFloat / prevLeftDosage)
              ? 0
              : (x.dosageInFloat / prevLeftDosage) * weight;
            let dosage = getFixedDosage(dosageInFloat);
            x.dosageInFloat = dosageInFloat;
            x.price =
              Math.ceil(
                ((dosage *
                  (state.isRawType
                    ? newList[index].formulaHerbs[herbIndex].rawPrice ?? 0
                    : newList[index].formulaHerbs[herbIndex].granularPrice ??
                      0)) /
                  10000) *
                  100
              ) / 100;
            x.dosage = dosage;
          }
        });
      }
      if (action.payload.isOuterLocked) {
        let weight =
          state.overall.totalDosage - parseFloat(action.payload.dosage);
        newList.forEach((y) => {
          y.formulaHerbs.forEach((x) => {
            if (x !== newList[index].formulaHerbs[herbIndex]) {
              let dosageInFloat = isNaN(x.dosageInFloat / prevLeftOverallDosage)
                ? 0
                : (x.dosageInFloat / prevLeftOverallDosage) * weight;
              let dosage = getFixedDosage(dosageInFloat);
              x.dosageInFloat = dosageInFloat;
              x.price =
                Math.ceil(
                  ((dosage *
                    (state.isRawType
                      ? x.rawPrice ?? 0
                      : x.granularPrice ?? 0)) /
                    10000) *
                    100
                ) / 100;
              x.dosage = dosage;
            }
          });
          y.formulaDosage = parseFloat(
            y.formulaHerbs
              .map((x) => x.dosage)
              .reduce((sum, val) => sum + val, 0)
          );
          y.formulaPrice = parseFloat(
            y.formulaHerbs
              .map((x) => x.price)
              .reduce((sum, val) => sum + val, 0)
              .toFixed(2)
          );
          y.formulaHerbs.forEach((z) => {
            z.percentage = y.formulaDosage
              ? z.dosageInFloat / y.formulaDosage
              : 0;
          });
        });

        newSingleHerbList.forEach((x) => {
          let dosageInFloat = isNaN(x.dosageInFloat / prevLeftOverallDosage)
            ? 0
            : (x.dosageInFloat / prevLeftOverallDosage) * weight;
          let dosage = getFixedDosage(dosageInFloat);
          x.dosageInFloat = dosageInFloat;
          x.price =
            Math.ceil(
              ((dosage *
                (state.isRawType ? x.rawPrice ?? 0 : x.granularPrice ?? 0)) /
                10000) *
                100
            ) / 100;
          x.dosage = dosage;
        });
      }
      let herbTotal = {
        totalPrice: parseFloat(
          newSingleHerbList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        ),
        totalDosage: parseFloat(
          newSingleHerbList
            .map((x) => x.dosage)
            .reduce((sum, val) => sum + val, 0)
        ),
      };

      newList[index].formulaDosage = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.dosage)
          .reduce((sum, val) => sum + val, 0)
      );
      newList[index].formulaPrice = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          herbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        singleHerbTotal: herbTotal,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) + herbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case MODIFICATION_BY_ID_RECEIVED: {
      return {
        ...state,
        modificationByIdList: action.payload,
      };
    }

    case SINGLE_HERB_ADDED_TO_LIST: {
      const item = {
        dosage: 0,
        dosageInFloat: 0,
        name: constructDisplayText(
          action.payload?.HERB_Display,
          action.payload?.HERB_Latin_Name,
          action.payload?.HERB_Chinese_Name,
          action.payload?.INV_ID_Granular
        ),
        id: action.payload.HERB_ID,
        rawRatio: action.payload.HERB_Raw_Ratio,
        granularUnit: action.payload.HERB_Granular_Unit,
        isToxic: action.payload.HERB_Is_Toxic,
        rawQuantity: action.payload.Raw_Quantity,
        granularQuantity: action.payload.Granular_Quantity,
        isCustom: false,
        price: 0,
        percentage: 0,
        rawPrice: action.payload.Price_Raw ?? 0,
        granularPrice: action.payload.Price_Granular ?? 0,
      };
      return {
        ...state,
        singleHerbList: state.singleHerbList.concat(item),
      };
    }
    case SINGLE_HERB_FROM_PRESCRIPTION_ADDED_TO_LIST: {
      const item = {
        dosage: parseFloat(action.payload.dosage),
        dosageInFloat: parseFloat(action.payload.dosage),
        name: constructDisplayText(
          action.payload?.herb_display,
          action.payload?.HERB_Latin_Name,
          action.payload?.HERB_Chinese_Name,
          action.payload?.INV_ID_Granular
        ),
        id: action.payload.herb_id,
        rawRatio: action.payload.HERB_Raw_Ratio,
        granularUnit: action.payload.HERB_Granular_Unit,
        isToxic: action.payload.HERB_Is_Toxic,
        rawQuantity: action.payload.Raw_Quantity,
        granularQuantity: action.payload.Granular_Quantity,
        isCustom: false,
        price:
          Math.ceil(
            ((parseFloat(action.payload.dosage) *
              (state.isRawType
                ? action.payload.price_raw ?? 0
                : action.payload.price_granular ?? 0)) /
              10000) *
              100
          ) / 100,
        percentage: 0,
        rawPrice: action.payload.price_raw ?? 0,
        granularPrice: action.payload.price_granular ?? 0,
      };
      return {
        ...state,
        singleHerbList: state.singleHerbList.concat(item),
      };
    }

    case SINGLE_HERB_REMOVED_FROM_LIST: {
      let newList = JSON.parse(JSON.stringify(state.singleHerbList));
      newList = newList.filter((x) => x.id !== action.payload);
      let newFormulaList = JSON.parse(JSON.stringify(state.formulaSection));
      let herbTotal = {
        totalPrice: parseFloat(
          newList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        ),
        totalDosage: parseFloat(
          newList.map((x) => x.dosage).reduce((sum, val) => sum + val, 0)
        ),
      };
      let totalDosage = parseFloat(
        newFormulaList
          .map((x) => x.formulaDosage)
          .reduce((sum, val) => sum + val, 0) + herbTotal.totalDosage
      );
      newFormulaList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });

      newList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        singleHerbList: newList,
        formulaSection: newFormulaList,
        singleHerbTotal: herbTotal,
        overall: {
          totalPrice: parseFloat(
            (
              state.formulaSection
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) + herbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case SINGLE_HERB_ITEM_EDITED: {
      const index = state.singleHerbList.findIndex(
        (x) => x.id === action.payload.id
      );
      const newList = JSON.parse(JSON.stringify(state.singleHerbList));
      const newFormulaSection = JSON.parse(
        JSON.stringify(state.formulaSection)
      );
      let prevLeftDosage =
        state.singleHerbTotal.totalDosage - newList[index].dosage;
      let prevLeftOverallDosage =
        state.overall.totalDosage - newList[index].dosage;
      newList[index].dosage = parseFloat(action.payload.dosage);
      newList[index].dosageInFloat = parseFloat(
        parseFloat(action.payload.dosage)
      );
      newList[index].price =
        Math.ceil(
          ((parseFloat(action.payload.dosage) *
            (state.isRawType
              ? newList[index].rawPrice ?? 0
              : newList[index].granularPrice ?? 0)) /
            10000) *
            100
        ) / 100;
      if (action.payload.isLocked) {
        let weight =
          state.singleHerbTotal.totalDosage - parseFloat(action.payload.dosage);
        newList.forEach((x) => {
          if (x !== newList[index]) {
            let dosageInFloat = isNaN(x.dosageInFloat / prevLeftDosage)
              ? 0
              : (x.dosageInFloat / prevLeftDosage) * weight;
            let dosage = getFixedDosage(dosageInFloat);

            x.dosageInFloat = dosageInFloat;
            x.price =
              Math.ceil(
                ((dosage *
                  (state.isRawType
                    ? newList[index].rawPrice ?? 0
                    : newList[index].granularPrice ?? 0)) /
                  10000) *
                  100
              ) / 100;
            x.dosage = dosage;
          }
        });
      }
      if (action.payload.isOuterLocked) {
        let weight =
          state.overall.totalDosage - parseFloat(action.payload.dosage);
        newList.forEach((x) => {
          if (x !== newList[index]) {
            let dosageInFloat =
              (x.dosageInFloat / prevLeftOverallDosage) * weight;
            let dosage = getFixedDosage(dosageInFloat);
            x.dosageInFloat = dosageInFloat;
            x.price =
              Math.ceil(
                ((dosage *
                  (state.isRawType
                    ? newList[index].rawPrice ?? 0
                    : newList[index].granularPrice ?? 0)) /
                  10000) *
                  100
              ) / 100;
            x.dosage = dosage;
          }
        });

        newFormulaSection.forEach((y) => {
          y.formulaHerbs.forEach((x) => {
            let dosageInFloat =
              (x.dosageInFloat / prevLeftOverallDosage) * weight;
            let dosage = getFixedDosage(dosageInFloat);
            x.dosageInFloat = dosageInFloat;
            x.price =
              Math.ceil(
                ((dosage *
                  (state.isRawType ? x.rawPrice ?? 0 : x.granularPrice ?? 0)) /
                  10000) *
                  100
              ) / 100;
            x.dosage = dosage;
          });
          y.formulaDosage = parseFloat(
            y.formulaHerbs
              .map((x) => x.dosage)
              .reduce((sum, val) => sum + val, 0)
          );
          y.formulaPrice = parseFloat(
            y.formulaHerbs
              .map((x) => x.price)
              .reduce((sum, val) => sum + val, 0)
              .toFixed(2)
          );
          y.formulaHerbs.forEach((z) => {
            z.percentage = y.formulaDosage
              ? z.dosageInFloat / y.formulaDosage
              : 0;
          });
        });
      }

      let herbTotal = {
        totalPrice: parseFloat(
          newList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        ),
        totalDosage: parseFloat(
          newList.map((x) => x.dosage).reduce((sum, val) => sum + val, 0)
        ),
      };
      let totalDosage = parseFloat(
        newFormulaSection
          .map((x) => x.formulaDosage)
          .reduce((sum, val) => sum + val, 0) + herbTotal.totalDosage
      );
      newList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      newFormulaSection.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });

      return {
        ...state,
        singleHerbList: newList,
        singleHerbTotal: herbTotal,
        formulaSection: newFormulaSection,
        overall: {
          totalPrice: parseFloat(
            (
              newFormulaSection
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) + herbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case FORMULA_TYPE_CHANGED_FROM_GRANULAR_TO_RAW: {
      let newFormulaSection = JSON.parse(JSON.stringify(state.formulaSection));
      let newSingleHerbList = JSON.parse(JSON.stringify(state.singleHerbList));
      let newSingleHerbTotal = JSON.parse(
        JSON.stringify(state.singleHerbTotal)
      );

      newFormulaSection.forEach((x) => {
        x.formulaHerbs.forEach((y) => {
          let dosageInFloat =
            (y.dosageInFloat /
              (action.payload.days == 0 ? 1 : action.payload.days) /
              y?.granularUnit ?? 1) * (y?.rawRatio ?? 1);
          if (Number.isNaN(dosageInFloat)) {
            dosageInFloat = 0;
          }
          let dosage = getFixedDosage(dosageInFloat);
          y.dosageInFloat = dosageInFloat;
          y.price =
            Math.ceil(
              ((parseFloat(dosage) *
                (action.payload.isRaw
                  ? y.rawPrice ?? 0
                  : y.granularPrice ?? 0)) /
                10000) *
                100
            ) / 100;
          y.dosage = dosage;
        });
        x.formulaPrice = parseFloat(
          x.formulaHerbs
            .map((y) => y.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        );
        x.formulaDosage = parseFloat(
          x.formulaHerbs.map((y) => y.dosage).reduce((sum, val) => sum + val, 0)
        );
        // x.formulaHerbs.forEach((z) => {
        //   z.percentage = z.dosageInFloat / x.formulaDosage;
        // });
      });

      newSingleHerbList.forEach((x) => {
        let dosageInFloat =
          (x.dosageInFloat /
            (action.payload.days == 0 ? 1 : action.payload.days) /
            x.granularUnit ?? 1) * (x.rawRatio ?? 1);
        if (Number.isNaN(dosageInFloat)) {
          dosageInFloat = 0;
        }
        let dosage = getFixedDosage(dosageInFloat);
        x.dosage = dosage;
        x.dosageInFloat = dosageInFloat;
        x.price =
          Math.ceil(
            ((dosage *
              (action.payload.isRaw ? x.rawPrice ?? 0 : x.granularPrice ?? 0)) /
              10000) *
              100
          ) / 100;
      });
      newSingleHerbTotal.totalPrice = parseFloat(
        newSingleHerbList
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      newSingleHerbTotal.totalDosage = newSingleHerbList
        .map((x) => x.dosage)
        .reduce((sum, val) => sum + val, 0);
      // newSingleHerbList.forEach((x) => {
      //   x.percentage = x.dosageInFloat / newSingleHerbTotal.totalDosage;
      // });

      let newOverall = JSON.parse(JSON.stringify(state.overall));
      newOverall.totalPrice = parseFloat(
        (
          newFormulaSection
            .map((x) => x.formulaPrice)
            .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalPrice
        ).toFixed(2)
      );
      newOverall.totalDosage = parseFloat(
        newFormulaSection
          .map((x) => x.formulaDosage)
          .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalDosage
      );
      return {
        ...state,
        isRawType: action.payload.isRaw,
        formulaSection: newFormulaSection,
        singleHerbList: newSingleHerbList,
        singleHerbTotal: newSingleHerbTotal,
        overall: newOverall,
      };
    }

    case FORMULA_TYPE_CHANGED_FROM_RAW_TO_GRANULAR: {
      let newFormulaSection = JSON.parse(JSON.stringify(state.formulaSection));
      let newSingleHerbList = JSON.parse(JSON.stringify(state.singleHerbList));
      let newSingleHerbTotal = JSON.parse(
        JSON.stringify(state.singleHerbTotal)
      );

      newFormulaSection.forEach((x) => {
        x.formulaHerbs.forEach((y) => {
          let dosageInFloat =
            (y.dosageInFloat *
              (action.payload.days == 0 ? 1 : action.payload.days) *
              y?.granularUnit ?? 1) / (y?.rawRatio ?? 1);
          if (Number.isNaN(dosageInFloat)) {
            dosageInFloat = 0;
          }
          let dosage = getFixedDosage(dosageInFloat);
          y.dosageInFloat = dosageInFloat;
          y.price =
            Math.ceil(
              ((parseFloat(dosage) *
                (action.payload.isRaw
                  ? y.rawPrice ?? 0
                  : y.granularPrice ?? 0)) /
                10000) *
                100
            ) / 100;
          y.dosage = dosage;
        });
        x.formulaPrice = parseFloat(
          x.formulaHerbs
            .map((y) => y.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        );
        x.formulaDosage = parseFloat(
          x.formulaHerbs.map((y) => y.dosage).reduce((sum, val) => sum + val, 0)
        );
        // x.formulaHerbs.forEach((z) => {
        //   z.percentage = z.dosageInFloat / x.formulaDosage;
        // });
      });

      newSingleHerbList.forEach((x) => {
        let dosageInFloat =
          (x.dosageInFloat *
            (action.payload.days == 0 ? 1 : action.payload.days) *
            x.granularUnit ?? 1) / (x.rawRatio ?? 1);
        if (Number.isNaN(dosageInFloat)) {
          dosageInFloat = 0;
        }
        let dosage = getFixedDosage(dosageInFloat);
        x.dosage = dosage;
        x.dosageInFloat = dosageInFloat;
        x.price =
          Math.ceil(
            ((dosage *
              (action.payload.isRaw ? x.rawPrice ?? 0 : x.granularPrice ?? 0)) /
              10000) *
              100
          ) / 100;
      });
      newSingleHerbTotal.totalPrice = parseFloat(
        newSingleHerbList
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      newSingleHerbTotal.totalDosage = newSingleHerbList
        .map((x) => x.dosage)
        .reduce((sum, val) => sum + val, 0);
      // newSingleHerbList.forEach((x) => {
      //   x.percentage = x.dosageInFloat / newSingleHerbTotal.totalDosage;
      // });

      let newOverall = JSON.parse(JSON.stringify(state.overall));
      newOverall.totalPrice = parseFloat(
        (
          newFormulaSection
            .map((x) => x.formulaPrice)
            .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalPrice
        ).toFixed(2)
      );
      newOverall.totalDosage = parseFloat(
        newFormulaSection
          .map((x) => x.formulaDosage)
          .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalDosage
      );
      return {
        ...state,
        isRawType: action.payload.isRaw,
        formulaSection: newFormulaSection,
        singleHerbList: newSingleHerbList,
        singleHerbTotal: newSingleHerbTotal,
        overall: newOverall,
      };
    }

    case FORMULA_TYPE_CHANGED: {
      let newFormulaSection = JSON.parse(JSON.stringify(state.formulaSection));
      let newSingleHerbList = JSON.parse(JSON.stringify(state.singleHerbList));
      let newSingleHerbTotal = JSON.parse(
        JSON.stringify(state.singleHerbTotal)
      );
      let newOverall = JSON.parse(JSON.stringify(state.overall));

      //filtering locked formulas
      let lockedFormulaList = newFormulaSection.filter((x) => x.isLocked);
      let lockedFormulaTotalDosage = lockedFormulaList
        .map((x) => x.formulaDosage)
        .reduce((sum, val) => sum + val, 0);
      let overallGramToChange = action.payload.gram - lockedFormulaTotalDosage;

      let nonLocketFormulaTotal =
        state.overall.totalDosage - lockedFormulaTotalDosage;
      if (state.singleHerbLocked) {
        overallGramToChange =
          overallGramToChange - state.singleHerbTotal.totalDosage;
        nonLocketFormulaTotal =
          nonLocketFormulaTotal - state.singleHerbTotal.totalDosage;
      }

      newFormulaSection.forEach((x) => {
        if (!x.isLocked) {
          x.formulaHerbs.forEach((y) => {
            let dosageInFloat =
              (x.formulaDosage / nonLocketFormulaTotal) *
              (y.dosageInFloat / x.formulaDosage) *
              overallGramToChange;
            if (Number.isNaN(dosageInFloat)) {
              dosageInFloat = 0;
            }
            let dosage = getFixedDosage(dosageInFloat);
            y.dosageInFloat = dosageInFloat;
            y.price =
              Math.ceil(
                ((parseFloat(dosage) *
                  (action.payload.isRaw
                    ? y.rawPrice ?? 0
                    : y.granularPrice ?? 0)) /
                  10000) *
                  100
              ) / 100;
            y.dosage = dosage;
          });
          x.formulaPrice = parseFloat(
            x.formulaHerbs
              .map((y) => y.price)
              .reduce((sum, val) => sum + val, 0)
              .toFixed(2)
          );
          x.formulaDosage = parseFloat(
            x.formulaHerbs
              .map((y) => y.dosage)
              .reduce((sum, val) => sum + val, 0)
          );
          x.formulaHerbs.forEach((z) => {
            z.percentage = x.formulaDosage
              ? z.dosageInFloat / x.formulaDosage
              : 0;
          });
        }
      });
      if (!state.singleHerbLocked) {
        newSingleHerbList.forEach((x) => {
          let dosageInFloat =
            (state.singleHerbTotal.totalDosage / nonLocketFormulaTotal) *
            (x.dosageInFloat / state.singleHerbTotal.totalDosage) *
            overallGramToChange;
          if (Number.isNaN(dosageInFloat)) {
            dosageInFloat = 0;
          }
          let dosage = getFixedDosage(dosageInFloat);
          x.dosage = dosage;
          x.dosageInFloat = dosageInFloat;
          x.price =
            Math.ceil(
              ((dosage *
                (action.payload.isRaw
                  ? x.rawPrice ?? 0
                  : x.granularPrice ?? 0)) /
                10000) *
                100
            ) / 100;
        });
        newSingleHerbTotal.totalPrice = parseFloat(
          newSingleHerbList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        );
        newSingleHerbTotal.totalDosage = newSingleHerbList
          .map((x) => x.dosage)
          .reduce((sum, val) => sum + val, 0);
        newSingleHerbList.forEach((x) => {
          x.percentage = newSingleHerbTotal.totalDosage
            ? x.dosageInFloat / newSingleHerbTotal.totalDosage
            : 0;
        });
      }
      let totalDosage = parseFloat(
        newFormulaSection
          .map((x) => x.formulaDosage)
          .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalDosage
      );
      newFormulaSection.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });

      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      newOverall.totalPrice = parseFloat(
        (
          newFormulaSection
            .map((x) => x.formulaPrice)
            .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalPrice
        ).toFixed(2)
      );
      newOverall.totalDosage = totalDosage;
      return {
        ...state,
        isRawType: action.payload.isRaw,
        formulaSection: newFormulaSection,
        singleHerbList: newSingleHerbList,
        singleHerbTotal: newSingleHerbTotal,
        overall: newOverall,
      };
    }

    case SINGLE_HERB_TOTAL_CHANGED: {
      let newFormulaSection = JSON.parse(JSON.stringify(state.formulaSection));
      let newSingleHerbList = JSON.parse(JSON.stringify(state.singleHerbList));
      let newSingleHerbTotal = JSON.parse(
        JSON.stringify(state.singleHerbTotal)
      );
      let newOverall = JSON.parse(JSON.stringify(state.overall));
      newSingleHerbList.forEach((x) => {
        let dosageInFloat = x.percentage * action.payload;
        let dosage = getFixedDosage(dosageInFloat);
        x.dosage = dosage;
        x.dosageInFloat = dosageInFloat;
        x.price =
          Math.ceil(((dosage * x.granularPrice ?? 0) / 10000) * 100) / 100;
      });
      newSingleHerbTotal.totalPrice = parseFloat(
        newSingleHerbList
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      newSingleHerbTotal.totalDosage = newSingleHerbList
        .map((x) => x.dosage)
        .reduce((sum, val) => sum + val, 0);
      newOverall.totalPrice = parseFloat(
        (
          newFormulaSection
            .map((x) => x.formulaPrice)
            .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalPrice
        ).toFixed(2)
      );
      newOverall.totalDosage = parseFloat(
        newFormulaSection
          .map((x) => x.formulaDosage)
          .reduce((sum, val) => sum + val, 0) + newSingleHerbTotal.totalDosage
      );
      return {
        ...state,
        singleHerbList: newSingleHerbList,
        singleHerbTotal: newSingleHerbTotal,
        overall: newOverall,
      };
    }

    case FORMULA_TOTAL_CHANGED: {
      const index = state.formulaSection.findIndex(
        (x) => x.formulaId === action.payload.formulaId
      );
      const newList = JSON.parse(JSON.stringify(state.formulaSection));
      newList[index].formulaHerbs.forEach((x) => {
        let dosageInFloat = x.percentage * action.payload.gram;
        let dosage = getFixedDosage(dosageInFloat);
        x.dosage = dosage;
        x.dosageInFloat = dosageInFloat;
        x.price =
          Math.ceil(((dosage * x.granularPrice ?? 0) / 10000) * 100) / 100;
      });
      newList[index].formulaDosage = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.dosage)
          .reduce((sum, val) => sum + val, 0)
      );
      newList[index].formulaPrice = parseFloat(
        newList[index].formulaHerbs
          .map((x) => x.price)
          .reduce((sum, val) => sum + val, 0)
          .toFixed(2)
      );
      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          state.singleHerbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    case ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED: {
      let herbList = [];

      const item = {
        dosage: parseFloat(
          (action.payload.data?.FORM_Dosage || action.payload.data?.dosage) ?? 0
        ),
        dosageInFloat: parseFloat(
          (action.payload.data?.FORM_Dosage || action.payload.data?.dosage) ?? 0
        ),
        name: "",
        id: 0,
        rawRatio:
          action.payload.data?.HERB_Raw_Ratio ||
          action.payload.data?.FORM_Raw_Ratio,
        granularUnit:
          action.payload.data?.HERB_Granular_Unit ||
          action.payload.data?.FORM_Granular_Unit,
        isToxic: false,
        rawQuantity: action.payload.data?.Raw_Quantity,
        granularQuantity:
          action.payload.data?.Granular_Quantity ||
          action.payload.data?.Quantity,
        isCustom: action.payload.data.is_custom_form
          ? 1
          : action.payload.data.isCustom
          ? 1
          : 0,
        price:
          Math.ceil(
            ((parseFloat(
              (action.payload.data?.FORM_Dosage ||
                action.payload.data?.dosage) ??
                0
            ) *
              (state.isRawType
                ? parseFloat(
                    action.payload.data?.Price_Raw ||
                      action.payload.data.price_raw
                  ) ?? 0
                : parseFloat(
                    action.payload.data?.Price_Granular ||
                      action.payload.data?.price_granular
                  ) ?? 0)) /
              10000) *
              100
          ) / 100,
        rawPrice:
          (action.payload.data?.Price_Raw || action.payload.data.price_raw) ??
          0,
        granularPrice:
          (action.payload.data?.Price_Granular ||
            action.payload.data?.price_granular) ??
          0,
        isAdditional: action.payload.data.is_form_additional,
        isModification: false || action.payload.data?.mod_id > 0,
        modId:
          action.payload.data?.mod_id > 0 ? action.payload.data?.mod_id : 0,
      };
      herbList.push(item);

      const formulaItem = {
        formulaHerbs: herbList,
        formulaName:
          action.payload.data.FORM_Display || action.payload.data.form_display,
        formulaId: action.payload.data.FORM_ID || action.payload.data.form_id,
        modificationName: action.payload.data?.modification_name,
        isLocked: false,
        isSuntenFormula: true,
        formulaDosage: parseFloat(
          herbList.map((x) => x.dosage).reduce((sum, val) => sum + val, 0)
        ),
        formulaPrice: parseFloat(
          herbList
            .map((x) => x.price)
            .reduce((sum, val) => sum + val, 0)
            .toFixed(2)
        ),
      };

      // if (action.payload.data.dosage > 0) {
      //   herbList.forEach((y) => {
      //     let dosageInFloat = y.percentage * action.payload.data.dosage;
      //     let dosage = getFixedDosage(dosageInFloat);
      //     y.dosageInFloat = dosageInFloat;
      //     y.price =
      //       Math.ceil(
      //         ((parseFloat(dosage) *
      //           (action.payload.data.isRaw
      //             ? y.rawPrice ?? 0
      //             : y.granularPrice ?? 0)) /
      //           10000) *
      //           100
      //       ) / 100;
      //     y.dosage = dosage;
      //   });
      //   formulaItem.formulaDosage = parseFloat(
      //     herbList.map((x) => x.dosage).reduce((sum, val) => sum + val, 0)
      //   );
      //   formulaItem.formulaPrice = parseFloat(
      //     herbList
      //       .map((x) => x.price)
      //       .reduce((sum, val) => sum + val, 0)
      //       .toFixed(2)
      //   );
      // }
      const newList = state.formulaSection.concat(formulaItem);
      let totalDosage = parseFloat(
        newList.map((x) => x.formulaDosage).reduce((sum, val) => sum + val, 0) +
          state.singleHerbTotal.totalDosage
      );
      newList.forEach((y) => {
        y.formulaHerbs.forEach((x) => {
          x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
        });
      });
      const newSingleHerbList = JSON.parse(
        JSON.stringify(state.singleHerbList)
      );
      newSingleHerbList.forEach((x) => {
        x.percentage = totalDosage ? x.dosageInFloat / totalDosage : 0;
      });
      return {
        ...state,
        formulaSection: newList,
        singleHerbList: newSingleHerbList,
        overall: {
          totalPrice: parseFloat(
            (
              newList
                .map((x) => x.formulaPrice)
                .reduce((sum, val) => sum + val, 0) +
              state.singleHerbTotal.totalPrice
            ).toFixed(2)
          ),
          totalDosage: totalDosage,
        },
      };
    }

    default:
      return state;
  }
};

const undoableTodos = undoable(formulaReducer, {
  filter: excludeAction([
    ALL_HERB_LIST_RECEIVED,
    CLASSIC_FORMULA_LIST_RECEIVED,
    CUSTOM_FORMULA_LIST_RECEIVED,
    DISEASES_RECEIVED,
    FAVORITE_FORMULA_LIST_RECEIVED,
    SUBCLASS_BY_ID_RECEIVED,
    CLEAR_UNFINALIZED_PRESCRIPTION,
    RENDER_FORMULA_LIST,
    MODIFICATION_BY_FORMULA_ID_RECEIVED,
    MODIFICATION_BY_ID_RECEIVED,
    FORMULA_BY_ID_RECEIVED,
  ]),
});

export default undoableTodos;
